<template>
  <section class="contact" id="contact">
    <div class="container">
      <h2 class="section-heading wow fadeInUp">Kontakt</h2>
      <div class="contact-grid">
        <!-- Form Column -->
        <div class="form-col wow slideInLeft">
          <h3>Napíšte nám</h3>
          <form @submit.prevent="handleSubmit">
            <div class="field">
              <label>Meno</label>
              <input type="text" placeholder="Vaše meno" v-model="contactForm.name" required />
            </div>
            <div class="field">
              <label>Email</label>
              <input type="email" placeholder="Váš email" v-model="contactForm.email" required />
            </div>
            <div class="field">
              <label>Telefón</label>
              <input type="text" placeholder="Vaše telefónne číslo" v-model="contactForm.mobile" />
            </div>
            <div class="field">
              <label>Správa</label>
              <textarea placeholder="Vaša správa" v-model="contactForm.message" required></textarea>
            </div>
            <button type="submit">
              <i class="fa fa-paper-plane"></i> Odoslať správu
            </button>
          </form>
        </div>

        <!-- Info Column -->
        <div class="info-col wow slideInRight">
          <h3>Skontaktujte nás</h3>
          <p class="intro-text">
            Ak máte akékoľvek otázky alebo záujem o naše služby, neváhajte nás kontaktovať.
            Naša prívetivá a odborná obsluha je pripravená vám pomôcť.
          </p>
          <ul class="contact-list">
            <li>
              <span class="icon"><i class="fa fa-map-marker"></i></span>
              <span>Nitra 949 01, Štúrova 1441/46</span>
            </li>
            <li>
              <span class="icon"><i class="fa fa-phone"></i></span>
              <a href="tel:0376503689">037/650 36 89</a>
            </li>
            <li>
              <span class="icon"><i class="fa fa-envelope"></i></span>
              <a href="mailto:diamond46nitra@gmail.com">diamond46nitra@gmail.com</a>
            </li>
          </ul>
          <div class="map-wrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10614.54220047989!2d18.0759046!3d48.3098604!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476b3f1c79f795c7:0x272cfd4be5b64c24!2sDiamond%20Gym!5e0!3m2!1sen!2ssk!4v1687868904798!5m2!1sen!2ssk"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
          <div class="social">
            <a href="https://www.facebook.com/diamond.gym.nr" aria-label="Facebook">
              <i class="fa fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/diamondgym/" aria-label="Instagram">
              <i class="fa fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/@diamondgym46" aria-label="YouTube">
              <i class="fa fa-youtube-play"></i>
            </a>
          </div>
          <p class="copy">2025 &copy; Diamond Gym — All rights reserved</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: "ContactSection",
  setup(_, { emit }) {
    const contactForm = reactive({
      name: "",
      email: "",
      mobile: "",
      message: "",
    })

    const handleSubmit = () => {
      emit('submit-form', { ...contactForm })
      alert("Správa bola odoslaná!")
      contactForm.name = ""
      contactForm.email = ""
      contactForm.mobile = ""
      contactForm.message = ""
    }

    return { contactForm, handleSubmit }
  }
}
</script>

<style scoped>
.contact {
  background-color: #111;
  color: #fff;
}

.section-heading {
  font-size: clamp(26px, 4vw, 36px);
  color: #E8B923;
  text-align: center;
  margin-bottom: 48px;
}

.section-heading::after {
  content: '';
  display: block;
  width: 56px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin: 12px auto 0;
}

.contact-grid {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

/* Form column */
.form-col {
  flex: 1 1 45%;
  background: #1a1a1a;
  padding: 36px 32px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.form-col h3,
.info-col h3 {
  font-size: 20px;
  color: #E8B923;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #2a2a2a;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.field label {
  font-size: 13px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.field input,
.field textarea {
  padding: 12px 14px;
  border: 1px solid #2d2d2d;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  background: #252525;
  color: #fff;
  transition: border-color 0.25s ease, background-color 0.25s ease;
  outline: none;
}

.field input:focus,
.field textarea:focus {
  border-color: #E8B923;
  background-color: #2a2a2a;
}

.field textarea {
  resize: vertical;
  min-height: 110px;
}

.form-col button[type="submit"] {
  width: 100%;
  padding: 14px;
  background-color: #E8B923;
  border: none;
  color: #000;
  font-size: 15px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.2s ease;
  margin-top: 6px;
  letter-spacing: 0.03em;
}

.form-col button[type="submit"]:hover {
  background-color: #d0a31e;
  transform: translateY(-1px);
}

.form-col button[type="submit"] .fa {
  margin-right: 8px;
}

/* Info column */
.info-col {
  flex: 1 1 45%;
}

.intro-text {
  font-size: 14px;
  line-height: 1.75;
  color: #bbb;
  margin-bottom: 24px;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin-bottom: 24px;
}

.contact-list li {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 14px;
  color: #ccc;
  padding: 10px 0;
  border-bottom: 1px solid #1e1e1e;
}

.contact-list li:last-child {
  border-bottom: none;
}

.contact-list .icon {
  width: 36px;
  height: 36px;
  background: rgba(232, 185, 35, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E8B923;
  font-size: 16px;
  flex-shrink: 0;
}

.contact-list a {
  color: #E8B923;
  transition: color 0.2s ease;
}

.contact-list a:hover {
  color: #fff;
}

/* Map */
.map-wrap {
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 24px;
  aspect-ratio: 16 / 7;
}

.map-wrap iframe {
  width: 100%;
  height: 100%;
  display: block;
}

/* Social */
.social {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.social a {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #1e1e1e;
  border: 1px solid #2a2a2a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #E8B923;
  transition: background-color 0.25s ease, color 0.25s ease, transform 0.2s ease;
}

.social a:hover {
  background-color: #E8B923;
  color: #000;
  transform: translateY(-2px);
}

.copy {
  font-size: 13px;
  color: #555;
}

/* Responsive */
@media (max-width: 900px) {
  .contact-grid {
    flex-direction: column;
    gap: 32px;
  }

  .form-col,
  .info-col {
    flex: 1 1 100%;
  }
}

@media (max-width: 540px) {
  .form-col {
    padding: 20px 16px;
  }

  .map-wrap {
    aspect-ratio: 16 / 9;
  }

  .social a {
    width: 46px;
    height: 46px;
    font-size: 20px;
  }
}
</style>
